import { render, staticRenderFns } from "./SuorganizatorDetails.vue?vue&type=template&id=5f64b128&scoped=true&"
import script from "./SuorganizatorDetails.vue?vue&type=script&lang=js&"
export * from "./SuorganizatorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f64b128",
  null
  
)

export default component.exports